import { render, staticRenderFns } from "./CategoriasComputacion.vue?vue&type=template&id=3e36419e&scoped=true"
import script from "./CategoriasComputacion.vue?vue&type=script&lang=js"
export * from "./CategoriasComputacion.vue?vue&type=script&lang=js"
import style0 from "./CategoriasComputacion.vue?vue&type=style&index=0&id=3e36419e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e36419e",
  null
  
)

export default component.exports